import axios from 'axios';
import { Application, ApplicationData, AIEvaluation, ChatRequest } from '../../../shared/types';

const API_BASE = '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const applicationsApi = {
  create: async (data: ApplicationData) => {
    const response = await api.post('/applications', data);
    return response.data;
  },

  getAll: async (filters?: {
    status?: string;
    minScore?: number;
    maxScore?: number;
    startDate?: string;
    endDate?: string;
    sort?: string;
    order?: string;
  }) => {
    const response = await api.get<Application[]>('/applications', { params: filters });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get<Application>(`/applications/${id}`);
    return response.data;
  },

  getEvaluation: async (id: number) => {
    const response = await api.get<AIEvaluation>(`/applications/${id}/evaluation`);
    return response.data;
  },

  updateStatus: async (id: number, status: 'pending' | 'approved' | 'rejected') => {
    const response = await api.patch(`/applications/${id}/status`, { status });
    return response.data;
  },

  getStats: async () => {
    const response = await api.get<{
      totalApplications: number;
      averageScore: number | null;
      pendingReview: number;
    }>('/applications/stats/summary');
    return response.data;
  },
};

export interface GrantPrecheckIssue {
  severity: 'critical' | 'high' | 'medium' | 'low';
  field: string;
  problem: string;
  recommendation: string;
}
export interface GrantPrecheckResult {
  compliant: boolean;
  score_0_100: number;
  issues: GrantPrecheckIssue[];
  missing_data: string[];
  strengths: string[];
  summary: string;
}

export const aiApi = {
  chat: async (request: ChatRequest) => {
    const response = await api.post<{ response: string }>('/ai/chat', request);
    return response.data.response;
  },
  // AI compliance precheck for grant/dev-grant applications (RAG + Azure OpenAI)
  precheckApplication: async (application_id: number, product_code?: string) => {
    const response = await api.post<{ success: boolean; application_id: number; kb_sources: string[]; precheck: GrantPrecheckResult }>(
      '/ai-modules/grant-writer/precheck-application',
      { application_id, product_code }
    );
    return response.data;
  },
};

export const exportApi = {
  downloadPDF: (id: number) => {
    window.open(`${API_BASE}/export/pdf/${id}`, '_blank');
  },

  downloadExcel: (filters?: {
    status?: string;
    minScore?: number;
    maxScore?: number;
    startDate?: string;
    endDate?: string;
  }) => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value.toString());
        }
      });
    }
    window.open(`${API_BASE}/export/excel?${params.toString()}`, '_blank');
  },
};
